//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BScroll from 'better-scroll'
import tableGrid from './tableGrid'
import cellGrid from './cellGrid'
import { FactoryUtils } from "@/utils/FactoryUtils"
export default {
    name:'mipLightbox',
    data(){
        return {
            planBScroll:null,
            showFlag:false,
            planDetails:{},
            cell:[],
            tabledata:{},

        }
    },
    props: {
        qqMusic: {
            type: Boolean,
            default() { return false}
        }
    },
    components: {
      cellGrid,
      tableGrid,
    },
    created(){

      FactoryUtils.planDetails().then(res =>{
        // console.log(res);
        this.planDetails = res
        if(this.qqMusic){
            this.cell = [{title: '有效期限',cont:'1年'}]
        }else{
            this.cell = res.cellList;
        }
        this.tabledata = res.tableList.table_content
      })
    },
    methods:{
        handler(ev){
            ev.preventDefault();
        },
        showToast(e){
            this.showFlag = true
            //console.log('111',this.planBScroll)
            this.$nextTick(() => {
                if (!this.planBScroll) {
                    this.planBScroll = new BScroll(this.$refs.planBox, {
                        click: true,
                        scrollY: true,
                    });
                } else {
                    this.planBScroll.refresh()
                }
            })
            document.body.addEventListener('touchmove', this.handler, { passive: false });
        },
        close(){
            this.showFlag = false;
            this.planBScroll = null;
            document.body.removeEventListener('touchmove', this.handler, { passive: false });
        }
    }
}
